// this is used to display Next modals on JS SDK course content pages
// while maintaining css isolation between Next and the JS SDK
export default {
  open:  () => { $('body').addClass('platform-modal-open') },
  close: () => { setTimeout(() => $('body').removeClass('platform-modal-open'), 500) } // setTimeout to wait for modal out transition
}
